import { render, staticRenderFns } from "./xiugaifeiyong.vue?vue&type=template&id=f419bf36&scoped=true&"
import script from "./xiugaifeiyong.vue?vue&type=script&lang=js&"
export * from "./xiugaifeiyong.vue?vue&type=script&lang=js&"
import style0 from "./xiugaifeiyong.vue?vue&type=style&index=0&id=f419bf36&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f419bf36",
  null
  
)

export default component.exports